import { useContext } from 'react';
import { AuthLayout } from '../../components/layout/AuthLayout';
import { Button } from '../../components/buttons/button';
import { Input } from '../../components/ui/input';
import { ICONS } from '../../constants/imageConstants';
import AuthAlerts from '../../components/common/AuthAlerts';
import { authService } from '../../services/authService';
import { AuthContext } from '../../context/AuthContext';
import { toastService } from '../../services/toastService';
import { useAuthForm } from '../../hooks/useAuthForm';

const SetPasswordPage = () => {
  const { user, logout } = useContext(AuthContext);

  const {
    formData,
    submitting,
    error,
    setError,
    onChange,
    showPassword,
    setShowPassword,
    showConfirm,
    setShowConfirm,
    handleSubmit
  } = useAuthForm({ password: '', confirmPassword: '' }, 'set-password');

  const onSubmit = e => {
    handleSubmit(
      e,
      () => authService.setPassword(formData.password, formData.confirmPassword),
      () => {
        toastService.success('Password set successfully!');
        return logout('password_set', user?.email);
      }
    );
  };

  return (
    <AuthLayout>
      <div className="mb-8 text-center">
        <h2 className="mb-2 text-3xl font-bold text-[#333333]">Set Your Password</h2>
        <p className="text-[#555555] font-medium text-lg">Create a password for your account.</p>
      </div>
      
      {error && (
        <div className="mb-6 animate-in fade-in slide-in-from-top-2">
          <AuthAlerts type="error" message={error} onClear={() => setError('')} />
        </div>
      )}

      <form onSubmit={onSubmit} className="space-y-6" noValidate>
        <div className="relative">
          <Input 
            id="new-password" 
            name="password"
            label="Password" 
            type={showPassword ? 'text' : 'password'} 
            value={formData.password} 
            onChange={onChange} 
            placeholder="Enter your password" 
            className="input-base"
          />
          <button type="button" onClick={() => setShowPassword(!showPassword)} className="absolute bottom-[13px] right-3 text-gray-400 hover:text-gray-600">
            <img src={showPassword ? ICONS.EYE : ICONS.EYE_OFF} alt="Toggle" className="h-5 w-5" />
          </button>
        </div>
        <div className="relative">
          <Input
            id="confirm-password"
            name="confirmPassword"
            label="Confirm Password"
            type={showConfirm ? 'text' : 'password'}
            value={formData.confirmPassword}
            onChange={onChange}
            placeholder="Confirm your password"
            className="input-base"
          />
          <button type="button" onClick={() => setShowConfirm(!showConfirm)} className="absolute bottom-[13px] right-3 text-gray-400 hover:text-gray-600">
            <img src={showConfirm ? ICONS.EYE : ICONS.EYE_OFF} alt="Toggle" className="h-5 w-5" />
          </button>
        </div>
        <Button variant="primary" className="w-full" size="large" disabled={submitting || !formData.password} type="submit" loading={submitting}>
          {submitting ? 'Setting Password...' : 'Set Password'}
        </Button>
      </form>
    </AuthLayout>
  );
};

export default SetPasswordPage;
